var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26406",
    x: 3,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    fill: "url(#paint0_linear_3806_6457)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292204",
    cx: 11.9395,
    cy: 5.63999,
    rx: 9.42,
    ry: 3.84,
    stroke: "currentColor",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 292202",
    d: "M3.26531 10.3C2.78516 10.7608 2.51953 11.2678 2.51953 11.8C2.51953 13.9208 6.73701 15.64 11.9395 15.64C17.1421 15.64 21.3595 13.9208 21.3595 11.8C21.3595 11.2678 21.0939 10.7608 20.6138 10.3",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 292203",
    d: "M3.26531 16.46C2.78516 16.9208 2.51953 17.4278 2.51953 17.96C2.51953 20.0808 6.73701 21.8 11.9395 21.8C17.1421 21.8 21.3595 20.0808 21.3595 17.96C21.3595 17.4278 21.0939 16.9208 20.6138 16.46",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3806_6457",
    x1: 3.5,
    y1: 22,
    x2: 20.6595,
    y2: 6.31561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpActive);
export default __webpack_public_path__ + "static/media/xp-active.dca64341dff516511ef47640971b5175.svg";
export { ForwardRef as ReactComponent };